'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../../common.blocks/i-bem/i-bem.react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.declMod)({ glyph: 'type-tick' }, {
    block: 'icon',
    content: function content() {
        return _react2.default.createElement(
            'svg',
            { focusable: 'false', viewBox: '0 0 12 10', width: '0', height: '0', xmlns: 'http://www.w3.org/2000/svg' },
            _react2.default.createElement('path', { d: 'M.49 5.385l1.644-1.644 4.385 4.385L4.874 9.77.49 5.385zm4.384 1.096L10.356 1 12 2.644 6.519 8.126 4.874 6.48v.001z' })
        ); // eslint-disable-line
    }
});